import Errors from './Errors' ;
import axios from '@/util/axios'

export default class Form {

    constructor(data = {}, clearForm = true) {

        this.clearForm = clearForm
        this.originalData = data;
        this.isSubmitted = false;
        this._asFormData = false

        for (let field in data) {
            this[field] = data[field];
        }

        this.errors = new Errors(data);
    }

    asForm(){
        this._asFormData = false;
        return this
    }
    asFormData(){
        this._asFormData = true;
        return this
    }
    clearFormAfterSuccessResponse(status){
        this.clearForm = status;
    }

    dontClear() {
        this.clearForm = false;
        return this
    }

    data(method) {

        if(this._asFormData) {
            return this.buildFormData(method)
        }

        let data = {};

        for (let property in this.originalData) {
            data[property] = this[property];
        }

        return data;
    }

    buildFormData(method) {

        let data = new FormData();

        for (let property in this.originalData) {


            var value = this[property];

            if (typeof value === "boolean") {
                value = (value === true) ? 1 : 0;
            }

            data.append(property, value);
        }

        if (method == 'delete' || method == 'patch' || method == 'put') {
            data.append('_method', method);
        }

        return data;
    }

    reset() {
        if(this.clearForm) {
            for (let field in this.originalData) {
                if(Array.isArray(this[field])){
                    this[field] = [];
                }else{
                    this[field] = '';
                }
            }
        }
        this.errors.clear();
    }

    get(url, options = {}){
        return this.submit('get', url, options);
    }

    post(url, options = {}) {
        return this.submit('post', url, options);
    }

    put(url, options = {}) {
        return this.submit('put', url, options);
    }

    patch(url, options = {}) {
        return this.submit('patch', url, options);
    }

    delete(url, options = {}) {
        return this.submit('delete', url, options);
    }

    submit(requestType, url, options) {
        this.isSubmitted = true;
        var method = requestType;
        requestType = this._asFormData ? 'post' : requestType;
        this.errors.clear();
        return new Promise((resolve, reject) => {
            axios.request({
                method: requestType,
                url: url,
                data: this.data(method)
            })
                .then(response => {
                    this.onSuccess(response.data, options);
                    resolve(response.data);
                })
                .catch(error => {
                    this.onFail(error.response.data);
                    if(options.hasOwnProperty('onFail')){
                        options.onFail()
                    }else{
                        reject(error.response.data);
                    }
                });
        });
    }
    onSuccess(data, options) {
        this.isSubmitted = false;
        if (!options.hasOwnProperty('clearForm') || options.clearForm == true) {
            this.reset();
        }
        this.errors.clear()
    }

    onFail(errors) {
        this.isSubmitted = false;
        var errorsBag = errors.hasOwnProperty('errors') ? errors.errors : {};
        this.errors.record(errorsBag, errors.message, errors.exception);
    }
}
